<script setup lang="ts">
/* eslint-disable max-len */
export interface IconEdit {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconEdit>(), { fill: "#A9B7D1", width: 16, height: 16 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.082 1.843c.481 0 .86.37.86.842a.843.843 0 0 1-.86.843H1.72v10.787h10.15v-5.63c0-.472.38-.842.861-.842.482 0 .86.37.86.842v6.472c0 .455-.413.843-.894.843H.86a.843.843 0 0 1-.86-.843V2.652c0-.455.378-.81.86-.81zM14.417 1c.086 0 .172.034.241.101l1.239 1.23c.137.118.137.337 0 .439L8.688 9.933c-.034.033-.069.067-.12.084l-2.03.792a.324.324 0 0 1-.362-.067.309.309 0 0 1-.086-.354L6.9 8.382a.27.27 0 0 1 .069-.118l7.208-7.163c.052-.067.155-.101.241-.101z"
      :fill="props.fill"
      fill-rule="evenodd"
    />
  </svg>
</template>
